import { ICondition, INews } from "api/types/_news";
import { CONFIG_OPTION_TOAST_INFO } from "common/toast";
import FeatherIcon from "feather-icons-react";
import { AI_MODEL_OPTIONS, CONFIG_ALLOW_SANITIZE_HTML } from "helpers/constans";
import HighlightText from "pages/News/Components/HighlightText";
import SpinnerScreen from "pages/News/Components/SpinnerScreen";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import 'react-json-pretty/themes/monikai.css';
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import sanitizeHtml from 'sanitize-html';

export interface Props {
    isOpen?: boolean;
    detail?: INews | null,
    isListNewsLoading: boolean;
    type_page_no_param: string;
    onClose?: () => void
    triggerRefresh?: (type?: string) => void;
    handlePreviousNews: (index: number | undefined) => void,
    handleNextNews: (index: number | undefined) => void,
}

const ModalPreviewArticle = ({
    isOpen = false,
    detail = null,
    isListNewsLoading,
    type_page_no_param,
    onClose,
    triggerRefresh,
    handlePreviousNews,
    handleNextNews,
}: Props) => {
    const { t, i18n } = useTranslation();

    const AI_MODEL_OPTIONS_LANG: any = AI_MODEL_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const [typeShowInfoRight, setTypeShowInfoRight] = useState<'IMAGE' | 'PROMPT'>('PROMPT');

    const [jsonTemplate, setJsonTemplate] = useState<any>('');

    const timeoutCallJsonTemplateRef = useRef<NodeJS.Timeout | null>(null);
    const [isLoadingJsonTemplate, setIsLoadingJsonTemplate] = useState<boolean>(false);

    const [newsDetail, setNewsDetail] = useState<INews | null>(null);
    const [condition, setCondition] = useState<ICondition | null>(null);
    const [isGenerating, setIsGenerating] = useState<boolean>(false);
    const [isInterval, setIsInterval] = useState<boolean>(false);

    const [isReGenerating, setIsReGenerating] = useState<boolean>(false);

    const onCloseClick = () => {
        setIsInterval((_prev) => false);
        setIsGenerating((_prev) => false);
        onClose && onClose();
    }

    const handleSetNewsDetail = (detail: INews | null) => {
        setNewsDetail((_prev) => detail);
    }


    const copyTextToClipboard = useCallback(async (textHTML: string) => {
        const replacedContent = String(textHTML).replace(/<br\s*\/?>/gi, '\n\n');
        const cleanHTML = sanitizeHtml(replacedContent, CONFIG_ALLOW_SANITIZE_HTML);
        if ('clipboard' in navigator) {
            await navigator.clipboard.writeText(cleanHTML);
        } else {
            document.execCommand('copy', true, cleanHTML);
        }
        toast(`${t('Copied to the clipboard.')}`, CONFIG_OPTION_TOAST_INFO);
    }, []);

    useEffect(() => {
        if (!newsDetail?.id) {
        }
    }, [condition?.template_id]);



    useEffect(() => {
        if (!!detail) {
            handleSetNewsDetail(detail);
        }
        return () => {
            setCondition((_prev) => null);
            setJsonTemplate((_prev: any) => '');
            setTypeShowInfoRight((_prev: any) => 'PROMPT');
        }
    }, [JSON.stringify(detail)]);


    const clickShowInfoRight = () => {
        setTypeShowInfoRight((_prev) => _prev === 'IMAGE' ? 'PROMPT' : 'IMAGE');
    }

    useEffect(() => {
        if (timeoutCallJsonTemplateRef.current) {
            clearTimeout(timeoutCallJsonTemplateRef.current);
        }

        return () => {
            if (timeoutCallJsonTemplateRef.current) {
                clearTimeout(timeoutCallJsonTemplateRef.current);
            }
        };
    }, []);

    const refLeft = useRef<any>(null);
    const refRight = useRef<any>(null);
    const [position, setPosition] = useState<any>({ left1: 20, left2: 30, top1: 20, top2: 20 });

    useEffect(() => {
        const getPosition = () => {
            if (refLeft.current && refRight.current) {
                const leftRect = refLeft.current.getBoundingClientRect();
                const rightRect = refRight.current.getBoundingClientRect();
                setPosition((_prev: any) => ({ left1: leftRect.left, left2: rightRect.left, top1: leftRect.top, top2: rightRect.top }));
            }
        };

        // Timeout to ensure UI has rendered
        const timeoutId = setTimeout(() => {
            // Get position on mount
            getPosition();
        }, 0);

        // Optionally, track changes on window resize
        window.addEventListener("resize", getPosition);

        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener("resize", getPosition);
        };
    }, [JSON.stringify(newsDetail)]);


    const clickPreviousNews = (index: number | undefined) => {
        handlePreviousNews && handlePreviousNews(index);
    };

    const clickNextNews = (index: number | undefined) => {
        handleNextNews && handleNextNews(index);
    };

    return (
        <React.Fragment>
            <Modal
                isOpen={isOpen}
                centered={true}
                size="xl"
                className={`border-header-footer modal-fullscreen`}
                scrollable={false}
                toggle={onCloseClick}
                keyboard={true}
            >
                <ModalHeader toggle={onCloseClick} className="modal-title-flex-grow-1">
                    <div className="d-flex flex-column gap-0 gap-sm-2 fs-18 fs-md-20">
                        <div className="flex-grow-1">
                            {t('Vote')} <span className="mx-1">{`>`}</span> {t('Article')} : <span style={{ backgroundColor: '#ffff00' }}>{newsDetail?.keyword || ''}</span>
                        </div>
                        <div className="d-flex flex-wrap fs-14">
                            <div className="me-2">
                                <span style={{ backgroundColor: '#ffff00' }}>{newsDetail?.keyword || ''}</span>
                            </div>
                            <div className="mx-2 text-danger">|</div>
                            <div className="me-2 fw-normal">
                                {t('Campaign')}: <span className="fw-bold">{newsDetail?.news_campaign?.campaign_name || '-'}</span>
                            </div>
                            <div className="mx-2 ms-0 text-danger">|</div>
                            <div className="me-2 fw-normal">
                                {t('Category')}: <>
                                    {(newsDetail?.source_vote_keyword?.categories || [])?.map((_c: any) => (
                                        <span className="badge bg-primary-subtle text-primary" key={_c?.category_id}>{_c?.title} </span>
                                    ))}
                                </>
                            </div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody className="position-relative">
                    <span className="position-absolute text-success fs-13 text-end px-2 d-none d-lg-block" style={{
                        top: position?.top1,
                        left: position?.left1 + 10,
                        transform: `translateY(-${position?.top1 - 10}px)`,
                        zIndex: 10,
                        backgroundColor: 'var(--vz-secondary-bg)'
                    }}>
                        {t('Generated News')}
                    </span>
                    <span className="position-absolute text-primary fs-13 text-end px-2 d-none d-lg-block" style={{
                        top: position?.top2,
                        left: position?.left2 + 10,
                        transform: `translateY(-${position?.top2 - 10}px)`,
                        zIndex: 10,
                        backgroundColor: 'var(--vz-secondary-bg)'
                    }}>
                        {typeShowInfoRight === 'IMAGE' ? t('Image') : t('Prompt')}
                    </span>
                    <div className="h-100-pc w-100 overflow-x-hidden">
                        <Row className="w-100-pc px-0 h-100-pc">
                            <Col lg={8} className={`h-100-pc mt-2 mt-md-0`}>
                                <span className="position-absolute text-success fs-13 text-end px-2 d-block d-lg-none" style={{
                                    top: 0,
                                    left: 5,
                                    transform: `translateY(-${10}px)`,
                                    zIndex: 10,
                                    backgroundColor: 'var(--vz-secondary-bg)'
                                }}>
                                    {t('Generated News')}
                                </span>
                                <div ref={refLeft} className="inner-modal-body color-scrollbar-os position-relative " style={{ border: '1.5px dashed var(--vz-success)', minHeight: '50dvh' }}>
                                    <span className="d-flex align-items-center text-success position-absolute fs-13" style={{ top: 5, right: 10 }}>
                                        {!!newsDetail?.title && <span className="text-primary d-flex align-items-center cursor-pointer me-3" onClick={() => copyTextToClipboard(`${newsDetail?.title || ''}\n\n${newsDetail?.body}`)}><i className="ri ri-file-copy-line" style={{ transform: 'translateY(1px)' }} /> {t('Copy')}</span>}
                                    </span>
                                    <div className="p-2">
                                        {(!!isGenerating || !!isReGenerating) ? <SpinnerScreen zIndex={9} isShow={true} /> : (
                                            <>
                                                <p className="mb-3 fs-22 fs-md-23" style={{ lineHeight: '170%', fontWeight: 600 }}>
                                                    <HighlightText text={newsDetail?.title || ''} keyword={newsDetail?.keyword || ''} sub_keyword={newsDetail?.keyword_sub} />
                                                </p>
                                                <p className="mb-3 mt-3 fs-17 fs-md-18" style={{ whiteSpace: 'pre-line', lineHeight: '170%' }}>
                                                    <HighlightText text={newsDetail?.body || ''} keyword={newsDetail?.keyword || ''} sub_keyword={newsDetail?.keyword_sub} />
                                                </p>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </Col>
                            <Col lg={4} className="h-100-pc ms-1 ms-lg-0 pe-3 me-lg-0 mt-4  mt-md-0">
                                <span className="position-absolute text-primary fs-13 text-end px-2 d-block d-lg-none" style={{
                                    top: 0,
                                    left: 5,
                                    transform: `translateY(-${10}px)`,
                                    zIndex: 9,
                                    backgroundColor: 'var(--vz-secondary-bg)'
                                }}>
                                    {typeShowInfoRight === 'IMAGE' ? t('Image') : t('Prompt')}
                                </span>
                                <Row className="h-100-pc align-content-between gap-3">
                                    {isLoadingJsonTemplate && <span
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            textAlign: 'center',
                                            zIndex: 99
                                        }}
                                    ><Spinner size="sm" className="text-primary fs-20" style={{ width: '40px', height: '40px' }}></Spinner></span>}
                                    <>
                                        <div className={`color-scrollbar-os position-relative box-source-news chill-1 px-0`} ref={refRight}>
                                            <div className="px-0 padding-json-preview" style={{ minHeight: 'calc(100dvh - 190px)' }}>
                                                <div className="p-0">
                                                    <div className="remove-margin-bottom-p-in-div set-w-100-img-in-div">
                                                        {
                                                            (typeShowInfoRight === 'IMAGE') ?
                                                                <div className="w-100 p-3 d-flex gap-3 flex-wrap" style={{ minWidth: '100px' }}>
                                                                    {(newsDetail?.source_vote_keyword?.images || [])?.map((_img: any) => (
                                                                        <div style={{ width: '150px', height: '150px' }} className="cursor-pointer" key={_img?.id}>
                                                                            {<img src={_img?.thumbnail_url || ''} className="flex-shrink-0 rounded w-100 h-100 object-fit-cover" alt={_img?.keyword_id} />}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                                : <div className="p-2 fs-17 fs-md-18" style={{ whiteSpace: 'break-spaces' }} dangerouslySetInnerHTML={{ __html: newsDetail?.source_vote_keyword?.prompt || '' }}></div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </ModalBody>
                <ModalFooter className="position-relative footer-button-new" lang={i18n?.language || 'en'}>
                    <div className="w-100 d-flex gap-2 justify-content-between align-items-center flex-wrap ">
                        <strong>

                        </strong>
                        <div className="d-flex flex-grow-1 gap-2 gap-sm-3 justify-content-end justify-content-sm-end mt-2 mt-sm-0">
                            <div className="d--dd-none d-md-flex">
                                <div className="btn-group btn-width-next-news">
                                    <button type="button" title={t('Previous News')} style={{ height: '40px' }} aria-pressed="false"
                                        className="btn fs-14 btn-secondary d-flex justify-content-center align-item-center"
                                        disabled={isListNewsLoading || !!newsDetail?.disabled_prev}
                                        onClick={() => clickPreviousNews(newsDetail?.index)}
                                    >
                                        {(isListNewsLoading && type_page_no_param === 'prev') ? <span style={{ transform: 'translateY(3px)', width: '18px' }}><Spinner size="sm" ></Spinner></span> : <FeatherIcon style={{ width: '18px' }} icon="chevron-left" className="fs-14" role="img" />}
                                    </button>
                                    <button type="button" title={t('Next News')} style={{ height: '40px' }} aria-pressed="false"
                                        className="btn fs-14 btn-secondary d-flex justify-content-center align-item-center"
                                        disabled={isListNewsLoading || !!newsDetail?.disabled_next}
                                        onClick={() => clickNextNews(newsDetail?.index)}
                                    >
                                        {(isListNewsLoading && type_page_no_param === 'next') ? <span style={{ transform: 'translateY(3px)', width: '18px' }}><Spinner size="sm" ></Spinner></span> : <FeatherIcon style={{ width: '18px' }} icon="chevron-right" className="fs-14" role="img" />}
                                    </button>
                                </div>
                            </div>
                            <div className="d-flex gap-2 gap-sm-3">
                                <button
                                    className="btn btn-primary fs-14 px-1 d-flex justify-content-center align-item-center"
                                    type="button"
                                    color="light"
                                    onClick={clickShowInfoRight}
                                    style={{ width: '120px' }}
                                >
                                    <span className="ms-1">{typeShowInfoRight === 'IMAGE' ? t('Prompt') : t('Image')}</span>
                                </button>
                                <button
                                    className="btn btn-secondary fs-14 px-1 d-flex justify-content-center align-item-center"
                                    type="button"
                                    color="light"
                                    onClick={onCloseClick}
                                    style={{ width: '75px' }}
                                >
                                    <i className="ri-close-fill" style={{ lineHeight: '22px' }} /> <span className="ms-1">{t("Button Close")}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </ModalFooter>
            </Modal>
        </React.Fragment >
    );
};

export default ModalPreviewArticle;